export default "__VITE_ASSET__C6GpQkNI__$_?component__"